var _circle, _path, _path2, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 54,
    fill: "#B6EDFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7567 83.1892C43.8171 83.1892 50.3513 76.655 50.3513 68.5946H21.1621C21.1621 76.655 27.6963 83.1892 35.7567 83.1892Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9458 68.5946C10.9458 62.1463 16.1732 56.9189 22.6215 56.9189H49.6215C56.0698 56.9189 61.2972 62.1463 61.2972 68.5946V68.5946H10.9458V68.5946Z",
    fill: "#00B0EF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_586_804",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 108,
    height: 108
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 54,
    fill: "#B6EDFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_586_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.8648 25.1757H4.74316V-1.82434H110.554V47.0676H89.7567C83.7114 47.0676 78.8107 42.1669 78.8107 36.1216C78.8107 30.0763 73.9101 25.1757 67.8648 25.1757Z",
    fill: "#00B0EF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar3);
export default __webpack_public_path__ + "static/media/avatar3.1d2fc1dc40a9a5f7a7b7419679f01021.svg";
export { ForwardRef as ReactComponent };